(() => {
  'use strict';

  const SECTION_IDS = ['mini-cart', 'cart-icon-bubble', 'mobile-cart-icon-bubble'];

  async function removeConfiguration(button) {
    const configurationId = button.dataset.kkRemoveConfiguration;
    if (!configurationId || button.disabled) return;

    const originalLabel = button.textContent;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.textContent = 'Usuwam…';

    try {
      const cartResponse = await fetch(`${theme.routes.cart_url}.js`, {
        headers: { Accept: 'application/json' }
      });
      if (!cartResponse.ok) throw new Error(window.KKText.cart_read_failed);

      const cart = await cartResponse.json();
      const updates = {};
      cart.items.forEach((item) => {
        if (item.properties?._kk_configuration_id === configurationId) updates[item.key] = 0;
      });
      if (!Object.keys(updates).length) throw new Error('Tego zestawu nie ma już w koszyku.');

      const response = await fetch(theme.routes.cart_update_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates, sections: SECTION_IDS, sections_url: location.pathname })
      });
      let payload = await response.json();
      if (!response.ok) throw new Error(payload.description || payload.message || window.KKText.set_remove_failed);

      payload = await window.KKCartPacking.reconcile({ sections: SECTION_IDS });

      const miniCart = document.querySelector('mini-cart');
      if (payload.sections && typeof miniCart?.renderContents === 'function') miniCart.renderContents(payload);
      else location.reload();
      document.dispatchEvent(new CustomEvent('kk:configuration-removed', { detail: { configurationId } }));
    } catch (error) {
      console.error('[KK cart groups] remove failed', error);
      button.disabled = false;
      button.removeAttribute('aria-busy');
      button.textContent = originalLabel;
      const header = button.closest('.kk-cart-group-header');
      let message = header?.querySelector('.kk-cart-group-error');
      if (!message && header) {
        message = document.createElement('p');
        message.className = 'kk-cart-group-error';
        message.setAttribute('role', 'alert');
        header.append(message);
      }
      if (message) message.textContent = error.message;
    }
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-kk-remove-configuration]');
    if (!button) return;
    event.preventDefault();
    removeConfiguration(button);
  });
})();
